import type { ErrorEvent } from "@sentry/browser";
import { isHeadlessBrowser } from "~/shared/constants/environment";

const NETWORK_ERROR_PATTERN =
  /failed to fetch|load failed|networkerror when attempting to fetch/i;

export const isDevHeadlessNetworkNoiseEvent = (
  event: ErrorEvent,
  context: { isDevelopment: boolean; isHeadless: boolean },
): boolean => {
  if (!context.isDevelopment) return false;
  if (!context.isHeadless) return false;
  return (event.exception?.values ?? []).some(
    (value) =>
      value.mechanism?.handled !== false &&
      NETWORK_ERROR_PATTERN.test(value.value ?? ""),
  );
};

export const isDevHeadlessNetworkNoise = (event: ErrorEvent): boolean =>
  isDevHeadlessNetworkNoiseEvent(event, {
    isDevelopment: event.environment === "development",
    isHeadless: isHeadlessBrowser(),
  });
